"use strict";

import {PropTypes, tutils} from "Subschema";

const {resolveKey, noop} = tutils;
export default function defaultValue(Clazz, key) {


    Clazz.contextTypes.valueManager = PropTypes.valueManager;

    Clazz::this.listener(key, function handleDefault(value, key, props, {valueManager}) {
        if (value == null) {
            return noop;
        }
        const resolvedKey = resolveKey(props.path, props.value);
        if (valueManager.path(resolvedKey) == null) {
            valueManager.update(resolvedKey, value);
        }
        return noop;
    });
}


/** WEBPACK FOOTER **
 ** ./src/resolver/defaultValue.js
 **/